<template>
  <el-dialog
    title="安装命令"
    :visible="dialogVisible"
    :before-close="close"
    :close-on-click-modal="false"
    width="700px"
    height="600px"
    class="dialog"
    center
  >
    <!-- 弹窗头部 -->
    <div slot="title" class="dialog-title">
      <!-- 图标 -->
      <div class="modalHeader_image">
        <img :src="appDetailInfo.logo || appLogoDef" aria-hidden="true" />
      </div>
      <!-- 应用名称 -->
      <div class="modalHeader_title">
        <div>{{ appDetailInfo.name }}</div>
      </div>
      <div class="button-right">
        <span class="title-close" @click="close"></span>
      </div>
    </div>
    <template>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="Helm V3" name="helm">
          <div style="margin-bottom: 30px">
          <!-- <div class="helmChartTitle">
            <div class="text-muted">先决条件</div>
          </div> -->
          <p class="hint_text">
           如果您还没有安装 Helm 或者不知道如何使用，您可以<a target="_blank" href="https://hub.grapps.cn/docs/install/Helm-Chart/kubernetes">参考详细文档</a>。
          </p>
          </div>


          <!-- 安装信息内容 -->
          <div class="helmChartInfo">
            <div class="helmChartTitle">
              <div class="text-muted">添加仓库</div>
            </div>
            <div class="helmChartContent">
              <div class="contentInstall">
                <div
                  style="
                    display: block;
                    overflow-x: auto;
                    padding: 16px;
                    color: rgb(0, 0, 0);
                    background-color: rgba(65, 117, 152, 0.1);
                  "
                >
                  <div class="language-bash" style="white-space: pre">
                    <span>{{ helmRepo }}</span>
                  </div>
                </div>
                <p class="contentInstall_text">
                  如果您已经添加过该仓库，可直接执行以下命令。
                </p>
              </div>
              <div>
                <div class="" style="margin-top: -14px">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="复制"
                    placement="right-end"
                  >
                    <button
                      type="button"
                      class="copyBtn"
                      aria-label="Copy command to clipboard"
                      v-clipboard:copy="helmRepo.trim()"
                      v-clipboard:success="onCopy"
                    >
                      <div
                        class="d-flex flex-row align-items-center"
                        aria-hidden="true"
                      >
                        <svg
                          stroke="currentColor"
                          fill="none"
                          stroke-width="2"
                          viewBox="0 0 24 24"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          height="1em"
                          width="1em"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            x="9"
                            y="9"
                            width="13"
                            height="13"
                            rx="2"
                            ry="2"
                          ></rect>
                          <path
                            d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"
                          ></path>
                        </svg>
                      </div>
                    </button>
                  </el-tooltip>
                </div>
              </div>
            </div>
          </div>
          <div class="helmChartInfo">
            <div class="helmChartTitle">
              <div class="text-muted">更新仓库</div>
            </div>
            <div class="helmChartContent">
              <div class="contentInstall">
                <div
                  style="
                    display: block;
                    overflow-x: auto;
                    padding: 16px;
                    color: rgb(0, 0, 0);
                    background-color: rgba(65, 117, 152, 0.1);
                  "
                >
                  <div class="language-bash" style="white-space: pre">
                    <span>{{ update }}</span>
                  </div>
                </div>
              </div>
              <div>
                <div class="">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="复制"
                    placement="right-end"
                  >
                    <button
                      type="button"
                      class="copyBtn"
                      aria-label="Copy"
                      v-clipboard:copy="update.trim()"
                      v-clipboard:success="onCopy"
                    >
                      <div
                        class="d-flex flex-row align-items-center"
                        aria-hidden="true"
                      >
                        <svg
                          stroke="currentColor"
                          fill="none"
                          stroke-width="2"
                          viewBox="0 0 24 24"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          height="1em"
                          width="1em"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            x="9"
                            y="9"
                            width="13"
                            height="13"
                            rx="2"
                            ry="2"
                          ></rect>
                          <path
                            d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"
                          ></path>
                        </svg>
                      </div>
                    </button>
                  </el-tooltip>
                </div>
              </div>
            </div>
          </div>
          <div class="helmChartInfo">
            <div class="helmChartTitle">
              <div class="text-muted">安装 Chart</div>
            </div>
            <div class="helmChartContent">
              <div class="contentInstall">
                <div
                  style="
                    display: block;
                    overflow-x: auto;
                    padding: 16px;
                    color: rgb(0, 0, 0);
                    background-color: rgba(65, 117, 152, 0.1);
                  "
                >
                  <div class="language-bash" style="white-space: pre">
                    <span>{{ helmCmd }}</span>
                  </div>
                </div>
              </div>
              <div>
                <div class="">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="复制"
                    placement="right-end"
                  >
                    <button
                      type="button"
                      class="copyBtn"
                      aria-label="Copy"
                      v-clipboard:copy="helmCmd.trim()"
                      v-clipboard:success="onCopy"
                      @click="this.handleCopyBtn"
                    >
                      <div
                        class="d-flex flex-row align-items-center"
                        aria-hidden="true"
                      >
                        <svg
                          stroke="currentColor"
                          fill="none"
                          stroke-width="2"
                          viewBox="0 0 24 24"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          height="1em"
                          width="1em"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            x="9"
                            y="9"
                            width="13"
                            height="13"
                            rx="2"
                            ry="2"
                          ></rect>
                          <path
                            d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"
                          ></path>
                        </svg>
                      </div>
                    </button>
                  </el-tooltip>
                </div>
              </div>
            </div>
          </div>

        </el-tab-pane>
        <el-tab-pane label="Rainbond 部署" name="rainbond">
          <div style="margin-bottom: 30px">
            <p class="hint_text">
              Rainbond 是一个不用懂 Kubernetes 的云原生应用管理平台。点击链接去<a target="_blank" href="https://www.rainbond.com">了解 Rainbond</a>。
            </p>
          </div>
          <div class="helmChartInfo">
            <h3>一、对接 Helm 仓库部署</h3>
            <div class="helmChartTitle">
              <div class="text-muted">通过 Rainbond 对接 Helm 仓库，具体步骤请<a target="_blank" href="https://hub.grapps.cn/docs/install/Helm-Chart/rainbond">参考详细文档</a></div>
            </div>
            <div class="helmChartContent">
              <div class="contentInstall">
                <div
                  style="
                    display: block;
                    overflow-x: auto;
                    padding: 16px;
                    color: rgb(0, 0, 0);
                    background-color: rgba(65, 117, 152, 0.1);
                  "
                >
                  <div class="language-bash" style="white-space: pre">
                    <span>{{ rainbondHelm }}</span>
                  </div>
                </div>
                <p class="contentInstall_text">
                  如果您已经添加过该仓库，可直接复制应用名称去 Rainbond 应用市场找到 Helm 商店去搜索此应用。
                </p>
              </div>
              <div>
                <div class="" style="margin-top: -14px">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="复制"
                    placement="right-end"
                  >
                    <button
                      type="button"
                      class="copyBtn"
                      aria-label="Copy command to clipboard"
                      v-clipboard:copy="rainbondHelm.trim()"
                      v-clipboard:success="onCopy"
                    >
                      <div
                        class="d-flex flex-row align-items-center"
                        aria-hidden="true"
                      >
                        <svg
                          stroke="currentColor"
                          fill="none"
                          stroke-width="2"
                          viewBox="0 0 24 24"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          height="1em"
                          width="1em"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            x="9"
                            y="9"
                            width="13"
                            height="13"
                            rx="2"
                            ry="2"
                          ></rect>
                          <path
                            d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"
                          ></path>
                        </svg>
                      </div>
                    </button>
                  </el-tooltip>
                </div>
              </div>
            </div>
          </div>

          <div class="helmChartInfo">
            <h3>二、Helm 命令行部署</h3>
            <div class="helmChartTitle">
              <div class="text-muted">通过 Rainbond 命令行方式部署，具体步骤请<a target="_blank" href="https://hub.grapps.cn/docs/install/Helm-Chart/rainbond#%E9%80%9A%E8%BF%87-helm-%E5%91%BD%E4%BB%A4%E8%A1%8C%E5%AE%89%E8%A3%85%E5%BA%94%E7%94%A8">参考详细文档</a></div>
            </div>
            <div class="helmChartContent">
              <div class="contentInstall">
                <div
                  style="
                    display: block;
                    overflow-x: auto;
                    padding: 16px;
                    color: rgb(0, 0, 0);
                    background-color: rgba(65, 117, 152, 0.1);
                  "
                >
                  <div class="language-bash" style="white-space: pre">
                    <span>{{ helmRepo }}</span>
                  </div>
                </div>
                <p class="contentInstall_text">
                  如果您已经添加过该仓库，可直接执行以下命令复制到同一个地方安装。
                </p>
              </div>
              <div>
                <div class="" style="margin-top: -14px">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="复制"
                    placement="right-end"
                  >
                    <button
                      type="button"
                      class="copyBtn"
                      aria-label="Copy command to clipboard"
                      v-clipboard:copy="helmRepo.trim()"
                      v-clipboard:success="onCopy"
                    >
                      <div
                        class="d-flex flex-row align-items-center"
                        aria-hidden="true"
                      >
                        <svg
                          stroke="currentColor"
                          fill="none"
                          stroke-width="2"
                          viewBox="0 0 24 24"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          height="1em"
                          width="1em"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            x="9"
                            y="9"
                            width="13"
                            height="13"
                            rx="2"
                            ry="2"
                          ></rect>
                          <path
                            d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"
                          ></path>
                        </svg>
                      </div>
                    </button>
                  </el-tooltip>
                </div>
              </div>
            </div>
          </div>

          <div class="helmChartInfo">
            <div class="helmChartTitle">
              <div class="text-muted">安装命令</div>
            </div>
            <div class="helmChartContent">
              <div class="contentInstall">
                <div
                  style="
                    display: block;
                    overflow-x: auto;
                    padding: 16px;
                    color: rgb(0, 0, 0);
                    background-color: rgba(65, 117, 152, 0.1);
                  "
                >
                  <div class="language-bash" style="white-space: pre">
                    <span>{{ helmCmd }}</span>
                  </div>
                </div>
                <p class="contentInstall_text">
                  执行完成之后，点击创建即可安装。
                </p>
              </div>
              <div>
                <div class="" style="margin-top: -14px">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="复制"
                    placement="right-end"
                  >
                    <button
                      type="button"
                      class="copyBtn"
                      aria-label="Copy command to clipboard"
                      v-clipboard:copy="helmCmd.trim()"
                      v-clipboard:success="onCopy"
                    >
                      <div
                        class="d-flex flex-row align-items-center"
                        aria-hidden="true"
                      >
                        <svg
                          stroke="currentColor"
                          fill="none"
                          stroke-width="2"
                          viewBox="0 0 24 24"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          height="1em"
                          width="1em"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            x="9"
                            y="9"
                            width="13"
                            height="13"
                            rx="2"
                            ry="2"
                          ></rect>
                          <path
                            d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"
                          ></path>
                        </svg>
                      </div>
                    </button>
                  </el-tooltip>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </template>

    <!-- 底部按钮 -->
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">关 闭</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { getStoreAvailableTags } from '@/api/appStore';
import { fetchAppInstallData } from '@/api/app';
import { mapState } from 'vuex';
import VueClipboard from 'vue-clipboard2';
import { errorHandle } from '../../../utils/error';
export default {
  name: 'AppHelmCreate',
  props: {
    dialogVisible: Boolean,
    onClose: Function,
    appDetailInfo: Object,
    helmChartVersion: String,
    marketID: String,
    helmVersionAlias: String
  },
  data() {
    return {
      centerDialogVisible: false,
      Loading: false,
      fileList: [],
      isFlag: true,
      helmRepo: '',
      helmCmd: '',
      activeName: 'helm',
      helmInstallUrl: 'curl -o helm https://pkg.goodrain.com/pkg/helm/v3.10.1/helm && chmod +x helm && mv ./helm /usr/local/bin',
      isShowInstall: false,
      update: 'helm repo update appstore',
      appLogoDef: require('../../../assets/images/app_icon.png'),
      rainbondHelm: 'https://charts.grapps.cn'
    };
  },
  computed: {
    myorgs() {
      return this.$store.state.user.userOrgs;
    },
    userInfo() {
      return this.$store.state.user.userInfo;
    }
  },
  created() {},
  mounted() {
    // const arrCmd = this.appDetailInfo.helmCmd.split('\n')
    this.helmRepo = 'helm repo add appstore https://charts.grapps.cn';
    this.helmCmd =
      'helm install ' +
      this.helmVersionAlias +
      ` appstore/${this.helmVersionAlias} ` +
      ' --version ' +
      this.helmChartVersion;
  },
  methods: {
    submit() {
      this.close();
    },
    close() {
      this.onClose && this.onClose();
    },
    onCopy(row) {
      this.$message({
        message: '复制成功',
        type: 'success'
      });
    },
    handleCopyBtn() {
      const params = this.$route.params;
      const marketId = '859a51f9bb3b48b5bfd222e3bef56425';
      // this.marketId = params.marketID;
      const appId = params.appID;
      fetchAppInstallData({
        marketId: marketId,
        appID: appId,
        version: this.helmChartVersion,
        userID: this.userInfo.userID || '',
        realName: this.userInfo.realName || '',
        phone: this.userInfo.phone || ''
      })
        .then((res) => {})
        .catch(() => {});
    },
    showInstall() {
      this.isShowInstall = !this.isShowInstall;
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.dialog-title {
  text-align: left;
  font-size: 14px;
  font-weight: 700;
  padding: 12px;
  overflow: hidden;
  display: flex;
  align-items: center;
  background-color: rgba(65, 117, 152, 0.1);
}
.dialog-title i {
  color: #45a4f9;
  /* color: #0B2278; */
  font-size: 20px;
  line-height: 0px;
}
.dialog-footer {
  text-align: right;
  font-size: 14px;
  font-weight: 700;
}
::v-deep .el-dialog__headerbtn {
    position: absolute;
    top: 24px;
    right: 20px;
    padding: 0;
    background: 0 0;
    border: none;
    outline: 0;
    cursor: pointer;
    font-size: 24px;
}
::v-deep .el-dialog__footer{
    border-top: 1px solid #e3e3e3;
}
::v-deep .el-dialog__header{
    height: 74px;
    line-height: 0px;
    align-items: center;
}
.modalHeader_image {
  height: 50px;
  min-width: 50px;
  width: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    max-height: 100%;
    max-width: 100%;
    vertical-align: middle;
  }
}
.modalHeader_title {
  margin-left: 6px;
  > div {
    font-size: 15px;
  }
}
.helmChartInfo {
  margin-bottom: 30px;
  .helmChartTitle {
    margin: 6px 0px;
  }
  .helmChartContent {
    display: flex;
    align-items: center;
    .contentInstall {
      flex-basis: calc(100% - 45px);
      max-width: calc(100% - 45px);
      margin-right: 12px;
      > div {
        display: block;
        font-size: 14px;
        margin-top: 0;
        overflow: auto;
      }
    }
  }
}
.copyBtn {
  height: 30px;
  width: 30px;
  background-color: #006fc2 !important;
  border-color: #006fc2;
  color: #fff;
}
.contentInstall_text {
  font-size: 12px;
  color: #bab9b9;
  margin-bottom: 0px !important;
}

.hint_text {
  font-size: 12px;
  color: #6c757d;
  margin: 6px 0px;
  a{
    color: #4d5d65;
    text-decoration: underline;
  }
}

.text-muted {
  color: #636a6e;
  a{
    color: #4d5d65;
    font-weight: 600;
    text-decoration: underline;
  }
}

::v-deep .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
  padding: 0 20px !important;
}
::v-deep .el-tabs--top .el-tabs__item.is-top:last-child {
  padding: 0 20px !important;
}
::v-deep .el-tabs__item.is-active{
  color: #fff;
  background: #106fc2;
}
::v-deep .el-tabs__item:hover{
  cursor: pointer;
}
::v-deep .el-tabs__active-bar{
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/views/appstore/components/InstallHelmChart.vue